import { useTranslation } from 'react-i18next'
import { Container } from '#app/ui/components/layout/container'
import { H2 } from '#app/ui/components/typography/h2'

type Credential = { value: string; label: string }

export const Founder = () => {
	const { t } = useTranslation('home')
	const paragraphs = t('founder.paragraphs', {
		returnObjects: true,
	}) as string[]
	const credentials = t('founder.credentials', {
		returnObjects: true,
	}) as Credential[]

	return (
		<section className="scroll-mt-24 bg-surface py-fluid-17" id="founder">
			<Container>
				<div className="relative mx-auto max-w-xl overflow-clip bg-background px-fluid-15 pb-[5rem] pt-fluid-15">
					<p className="text-sm text-muted-600">{t('founder.eyebrow')}</p>
					<H2 className="mt-fluid-9 text-balance text-fluid-3xl normal-case">
						{t('founder.heading')}
					</H2>
					<div className="mt-fluid-12 flex flex-col gap-fluid-11">
						{paragraphs.map(paragraph => (
							<p key={paragraph} className="text-muted-600">
								{paragraph}
							</p>
						))}
					</div>
					<img
						src="/img/signature.webp"
						alt={t('founder.signatureAlt')}
						width={600}
						height={224}
						className="relative z-10 mt-fluid-14 w-44"
					/>
					<p className="relative z-10 mt-fluid-9 text-sm text-muted-500">
						{t('founder.role')}
					</p>
					<img
						src="/img/andre-cutout.png"
						alt=""
						aria-hidden
						width={430}
						height={581}
						className="pointer-events-none absolute -bottom-[10.5rem] -right-2 w-64 select-none grayscale sm:-bottom-[13rem] sm:w-80"
					/>
				</div>
				<dl className="mx-auto mt-fluid-16 grid max-w-xl grid-cols-2 gap-fluid-11">
					{credentials.map(credential => (
						<div
							key={credential.label}
							className="flex flex-col-reverse items-center text-center"
						>
							<dt className="mt-fluid-8 text-sm text-muted-600">
								{credential.label}
							</dt>
							<dd className="text-fluid-3xl font-bold tracking-tight">
								{credential.value}
							</dd>
						</div>
					))}
				</dl>
			</Container>
		</section>
	)
}
